import { ILSTable } from '@common/components';
import { FC, useState } from 'react';
import { tableOnTimeConfig, tableOnTimeDateToTable } from '@common/table-configs/monitoring-dashboard/on-time';
import { ColumnTable, Dictionary, IndexedArray, RecordTableButton } from '@common/types';
import { tableCustom } from '@core/containers/table-custom';
import { MonitoringOnTimeDataModel } from '@common/types/dictionaries/monitoring-vehicle';
import { MonitoringExelData } from '@modules/monitoring/utils/create-exel-data';
import { addToTableExelButton } from '../../utils/exel-button';
import { addToTableShowViewedButton, hasUnviewed, tableViewedFilter } from '../../utils/viewed-button';
import { ILSDashboardViewedButtonComponent } from '../../components/viewed-button';
import { MonitoringTableTopLayout } from '@modules/monitoring/children/dashboard/tables/components/monitoring-table-top-layout';
import { showAttachment, useModalDoc } from '@modules/monitoring/hooks/use-modal-view-doc';
import { useGetWaypointTimeZone } from '@modules/monitoring/hooks/use-get-timezone';
import { useFocusRow } from '@components/data-display/table/hooks/row/use-focus-row';

interface IProps {
  dataSource: Array<MonitoringOnTimeDataModel> | IndexedArray<MonitoringOnTimeDataModel>;
  onContextOpen?: (record: MonitoringOnTimeDataModel, e: MouseEvent) => void;
  columns: ColumnTable<MonitoringOnTimeDataModel>[];
  recordTableButtons?: Array<RecordTableButton>;
  loadExel: (exelData: MonitoringExelData | undefined, fileName: string) => void;
  handleUpdateView?: ((id: string | number | string[] | number[], value: 0 | 1) => void) | undefined;
}

// Контейнер таблицы доставлено вовремя
export const MonitoringTableDeliveryOnTime: FC<IProps> = ({
  dataSource,
  loadExel,
  recordTableButtons,
  onContextOpen,
  handleUpdateView,
  ...props
}) => {
  const [showAll, setShowAll] = useState(true);
  const { setFocusRow, focusRow } = useFocusRow();
  const { DocViewModalContent, openFile } = useModalDoc();
  const { getWpTimeZone } = useGetWaypointTimeZone();

  const decoratedData = tableViewedFilter(
    tableOnTimeDateToTable({ dataSource, handleView: handleUpdateView, showAttachment: showAttachment({ openFile }), getWpTimeZone }),
    showAll
  );

  recordTableButtons = addToTableExelButton(recordTableButtons, loadExel, decoratedData, props.columns, Dictionary.OnTime);
  recordTableButtons = addToTableShowViewedButton(recordTableButtons, showAll, (val: boolean) => showAll !== val && setShowAll(val));

  return (
    <MonitoringTableTopLayout className="ontime">
      <ILSTable
        {...props}
        focusRow={focusRow}
        setFocusRow={setFocusRow}
        recordTableButtons={recordTableButtons}
        config={tableOnTimeConfig}
        dataSource={decoratedData}
        size={'small'}
        pagination={false}
        scroll={{ y: 'calc(100vh - 450px)' }}
        className="editable-table"
        bordered
        dictionary={Dictionary.OnTime}
        onContextOpen={onContextOpen}
      />
      <ILSDashboardViewedButtonComponent
        key={Dictionary.OnTime + 'button'}
        disabled={!hasUnviewed(decoratedData)}
        onClick={() => {
          handleUpdateView?.(
            tableViewedFilter(decoratedData, false).map((item) => item.ID.toString()),
            1
          );
        }}
      />
      {DocViewModalContent}
    </MonitoringTableTopLayout>
  );
};

export const ILSMonitoringOnTime = tableCustom(MonitoringTableDeliveryOnTime, tableOnTimeConfig, Dictionary.OnTime);
